import { render, staticRenderFns } from "./messenger-header.vue?vue&type=template&id=96619c24&scoped=true&"
import script from "./messenger-header.vue?vue&type=script&lang=js&"
export * from "./messenger-header.vue?vue&type=script&lang=js&"
import style0 from "./messenger-header.vue?vue&type=style&index=0&id=96619c24&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96619c24",
  null
  
)

export default component.exports